import React from "react";

const Phone = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" fillRule="evenodd" {...props}>
        <g fill="currentColor" fillRule="nonzero">
          <path d="M8.28 2H5C3.343 2 2 3.343 2 5v1c0 8.837 7.163 16 16 16h1c1.657 0 3-1.343 3-3v-3.28c0-.86-.55-1.624-1.368-1.897l-4.493-1.497-.158-.046c-.899-.22-1.843.208-2.263 1.048l-.679 1.356-.029-.016c-1.424-.821-2.627-1.984-3.497-3.377l-.198-.331 1.357-.678c.89-.445 1.317-1.477 1.002-2.421l-1.497-4.493C9.904 2.55 9.14 2 8.279 2zM5 4h3.279l1.498 4.493-2.257 1.13c-.48.24-.685.815-.465 1.305 1.203 2.667 3.35 4.814 6.017 6.017.49.22 1.066.015 1.306-.465l1.129-2.257L20 15.721V19c0 .552-.448 1-1 1h-1C10.268 20 4 13.732 4 6V5c0-.552.448-1 1-1z" />
        </g>
      </g>
    </svg>
  );
};

export default Phone;
